import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const pageContentSx: SystemStyleObject<Theme> = {
  minHeight: '70vh',
  position: 'relative',
  p: { xs: 2, md: 2.5 },
};

export const showPageTopButtonsSx: SystemStyleObject<Theme> = {
  '&:not(:empty)': {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    flexWrap: { xs: 'wrap', md: 'nowrap' },
    mt: { xs: 3, md: 0 },
  },
};

export const showPageHeaderWrapperSx: SystemStyleObject<Theme> = {
  display: { xs: 'block', md: 'flex' },
  justifyContent: { md: 'space-between' },
  alignItems: { md: 'center' },
  mb: 4,
};

export const showPageEntityHeaderWrapperSx: SystemStyleObject<Theme> = {
  flexGrow: 1,
  mr: 2.5,
  display: 'flex',
  flexDirection: 'column',
};

export const showPagePaperSx: SystemStyleObject<Theme> = {
  ...pageContentSx,
  mt: -3,
  backgroundColor: 'transparent',
};

export const getShowPageContentInnerSx = (
  hasSeparateSections?: boolean,
  minHeight?: string,
): SystemStyleObject<Theme> => ({
  position: 'relative',
  mx: { xs: -2, md: -2.5 },
  my: 0,
  borderRadius: '4px',
  minHeight: minHeight ?? '50vh',
  flexGrow: 1,
  width: { md: 'calc(100% - 235px)' },
  ...(hasSeparateSections
    ? {
        '& .section-details__wrapper': {
          backgroundColor: 'background.paper',
          borderRadius: '4px',
          m: '0 0 20px',
          pt: { xs: 2.25, md: 2.75 },
          px: { xs: 2, md: 2.5 },
          pb: { xs: 0, md: 0.5 },
        },
      }
    : {
        backgroundColor: 'background.paper',
        p: { xs: 2, md: 2.5 },
        '& .section-details__wrapper:not(:last-child)': {
          mb: 5.25,
          pb: 2.5,
          borderBottom: '1px solid',
          borderColor: 'border.default',
        },
      }),
});
